function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit_outline_28",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1213203,4.28868332 L23.7071068,5.87446976 C24.8786797,7.04604263 24.8786797,8.94553757 23.7071068,10.1171104 L21,12.8242172 L10.1463971,23.6778623 C9.30249088,24.5217199 8.15793756,24.9957901 6.96450829,24.9957901 L5.05,24.9957901 C3.91781626,24.9957901 3,24.0779738 3,22.9457901 L3,21.0313662 C3,19.8378471 3.47414138,18.6932152 4.31811116,17.849294 L15.172,6.99600366 L15.1715729,6.9957901 L17.8786797,4.28868332 C19.0502525,3.11711044 20.9497475,3.11711044 22.1213203,4.28868332 Z M16.5,8.49645271 L5.73228398,19.2635483 C5.26341188,19.7323934 5,20.3683 5,21.0313662 L5,22.9457901 C5,22.9734043 5.02238576,22.9957901 5.05,22.9957901 L6.96450829,22.9957901 C7.62752455,22.9957901 8.2633875,22.7324178 8.73222431,22.263608 L19.5,11.4964527 L16.5,8.49645271 Z M19.2928932,5.70289688 L18,6.9957901 L21,9.9957901 L22.2928932,8.70289688 C22.6834175,8.31237259 22.6834175,7.67920761 22.2928932,7.28868332 L20.7071068,5.70289688 C20.3165825,5.31237259 19.6834175,5.31237259 19.2928932,5.70289688 Z",
  id: "\\u21B3-Icon-Color",
  fill: "currentColor"
})));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.8fb26159.svg";
export { ForwardRef as ReactComponent };